function debugEnabled(): boolean {
    return process.env.SHOW_DEBUG == "true" || process.env.SHOW_DEBUG == "1";
}
export default debugEnabled;